<template>
  <div class="meta-drawer__content">
    <p class="meta-drawer__title">
      {{$t('feed.settings.metaSource.newSource.title')}}
    </p>


    <el-form
      :model="metaForm"
      ref="metaForm"
      label-width="120px"
      class="demo-ruleForm"
      v-loading="loading"
      label-position="top"
    >
      <el-form-item :label="$t('feed.settings.metaSource.newSource.form.name')" prop="network_list">
        <el-input size="small"
                  v-model="metaForm.title"
                  :rules="$t('feed.settings.metaSource.newSource.rules')"
                  :placeholder="$t('feed.settings.metaSource.newSource.form.name')"
        ></el-input>
      </el-form-item>

      <el-divider></el-divider>

      <ul class="meta-source-list">
        <template v-for="(item, index) in sourcesDictionary">
          <li class="meta-source-list__item" :key="item.name">
            <div style="margin-bottom: 10px">
              <i :class="`${item.preIcon} fa-${item.icon}`"></i> {{item.name}}
            </div>

            <net-source
              :source="null"
              :sources-by-net="sourcesByNet[index]"
              :net="index"
              @setSelectedSource="setSelectedSource"
              :source-name="item.name"
            />
          </li>
        </template>
      </ul>

      <div class="user-footer">
        <el-button
          size="medium"
          type="primary"
          @click="saveMeta('metaForm')">{{$t('feed.settings.metaSource.newSource.form.addButton')}}</el-button>
        <el-button
          size="medium"
          @click="resetForm('metaForm')">{{$t('feed.settings.metaSource.newSource.form.cancelButton')}}</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
  /*
    The component of adding a meta source
  */

  // components
  import notify from "../../../../../../helpers/notify";
  import NetSource from './NetSource';

  export default {
    name: 'NewMetaSource',
    props: {
      sourcesDictionary: {
        type: Object,
      },
      sourcesByNet: {
        type: Object
      },
    },
    data() {
      return {
        select: [],
        networks: [],
        loading: false,
        metaForm: {
          title: '',
          net: {},
        },
        selectedSource: {},
      };
    },
    methods: {
      setSelectedSource({select, net}) {
        this.selectedSource = {...this.selectedSource, ...{[net]: select.toString()}};
      },
      saveMeta(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.loading = true;
            let params = {
              id: 0,
              thread_id: this.$route.params.threadId,
              title: this.metaForm.title,
              ...this.selectedSource ,
              tg: '',
            };

            this.$emit('saveNewSource', params).then(() => {
              this.loading = false;
              notify.call(this, this.$t('feed.settings.metaSource.newSource.notify.add'), "success");
            });
          } else {
            this.loading = false;
            notify.call(this, this.$t('feed.settings.metaSource.newSource.notify.error'), "error");
            return false;
          }
        });
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      },
    },
    created() {
      for (let key in this.sourcesDictionary) {
        this.metaForm.net[key] = '';
      }
    },
    components: {
      NetSource,
    },
  };
</script>

<style>
  .meta-drawer__content {
    margin: 0 15px 0 15px;
    font-family: "Roboto", "Arial", sans-serif;
  }
  .meta-drawer__title {
    padding: 0;
    margin: 0;
    font-family: "Roboto", "Arial", sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 22px;
    line-height: 14px;
    color: #5E6D82;
  }
  .meta-drawer__content .el-select, .meta-drawer__content .el-input {
    display: block;
    width: 100%;
  }
</style>
